import { IGetGrupoAcessoDropDownUseCase } from "../../../presentation/useCases/read/get_grupo_acesso_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetGrupoAcessoDropDownUseCase
 */

export class GetGrupoAcessoDropDownUseCase implements IGetGrupoAcessoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getGrupoAcessoDropDown(): Promise<DropDown[]> {
    const gruposAcessoDropDown = await this.repository.getGruposAcessoDropDown();
    return gruposAcessoDropDown;
  }

}
